import { createContext, useContext } from "react";
import { WindowInstance, mainWindowInstance } from "../injection/windows/WindowInstance.js";

export const WindowInstanceContext = createContext(mainWindowInstance);

export const useWindowInstance = (): WindowInstance => {
  return useContext(WindowInstanceContext);
};
